import { render, staticRenderFns } from "./ClientSubscriptionComponent.vue?vue&type=template&id=65fba646&scoped=true&"
import script from "./ClientSubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./ClientSubscriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientSubscriptionComponent.vue?vue&type=style&index=0&id=65fba646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fba646",
  null
  
)

export default component.exports